import React, { useContext, useEffect, useRef, useState } from "react";
import CouponTemplate1 from "../CouponTemplate/CouponTemplate1";
import styles from "./Coupons.module.css";
import CouponDetails from "../CouponDetails/CouponDetails";
import { useUserAuth } from "../../context/UserAuthContext";
import Context from "../../context/Context";
import axios from "axios";
import CouponLoginScreen from "../CouponLoginScreen/CouponLoginScreen";
import { isEmpty } from "lodash";
import CartBanner from "../CouponCart/CartBanner";
import CouponCart from "../CouponCart/CouponCart";
import { useNavigate } from "react-router";
import { createSearchParams } from "react-router-dom";

const CarouselDot = ({ active, onClick, id }) => {
  const dotClass = `${
    active ? "w-[6px] h-[6px] rounded-full bg-[#000]" : "carousel-dot"
  }`;
  return <div className={dotClass} onClick={onClick} id={id} />;
};

export default function Coupons({
  coupons,
  setCoupons,
  handleClickCounterCampaign,
}) {
  const [showCoupon, setShowCoupon] = useState(false);
  const [showCouponCart, setShowCouponCart] = useState(false);
  const [couponData, setCouponData] = useState({});
  const [loading, setLoading] = useState(false);
  const [loginScreen, setLoginScreen] = useState(false);
  const { userIdToken, setSelectedCoupons, selectedCoupons, details } =
    useContext(Context);
  const {
    currentUser,
    setPreviousLocation,
    setShowLogin,
    reqForGenerate,
    setReqForGenerate,
    searchParams,
  } = useUserAuth();
  const token = userIdToken || currentUser?.accessToken;
  const navigate = useNavigate();
  let campaignId = details?._id;
  const handleShowCoupon = (data) => {
    handleClickCounterCampaign(
      data?.brandId,
      data?.videoName,
      data?.discountName,
      data?.brandName,
      "ads",
      "campaign"
    );
    switch (data?.type) {
      case "GENERATE":
        if (currentUser) {
          if (data?.generatedCoupon) {
            setCouponData(data);
            setShowCoupon(true);
          } else {
            handleGenerateCoupon(data);
          }
        } else {
          setCouponData(data);
          setLoginScreen(true);
        }
        break;
      case "INSTANT_SHOW":
        setCouponData(data);
        setShowCoupon(true);
        break;
      default:
        break;
    }
  };
  const handleLogin = () => {
    setPreviousLocation(window.location.pathname);
    setReqForGenerate(true);
    navigate(
      {
        pathname: `/signup`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      },
      {
        state: {
          previousLocation: window.location.pathname,
        },
      }
    );
  };
  const handleGenerateCoupon = async (data) => {
    try {
      setLoading(true);
      let config = {
        method: "PATCH",
        url: `${process.env.REACT_APP_GENENRATE_COUPON}/${campaignId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          videoName: data?.videoName,
        },
      };
      const resonse = await axios(config);
      let generatedCoupon = resonse?.data?.offer;
      let newCouponArray = coupons;
      let index = newCouponArray?.findIndex(
        (el) => el?.videoName == generatedCoupon?.videoName
      );
      if (index !== -1) {
        newCouponArray[index] = generatedCoupon;
      }
      setCoupons(newCouponArray);
      setShowCoupon(true);
      setCouponData(generatedCoupon);
      // handleSelectCoupon(generatedCoupon, true);
      setLoading(false);
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleSelectCoupon = (coupon, viewCoupon) => {
    let newCouponObj = coupon;
    newCouponObj.selected = !newCouponObj.selected;
    setSelectedCoupons((prevState) => {
      let couponArray = prevState;
      const isCouponSelected = prevState.some(
        (c) => c.videoName == newCouponObj.videoName
      );
      if (isCouponSelected) {
        return prevState.filter((c) => c.videoName !== newCouponObj.videoName);
      } else {
        return [...prevState, newCouponObj];
      }
    });
    setCoupons((prevState) => {
      let newCouponArray = prevState;
      let index = newCouponArray?.findIndex(
        (el) => el?.videoName == newCouponObj?.videoName
      );
      if (index !== -1) {
        newCouponArray[index] = newCouponObj;
      }
      return newCouponArray;
    });
    if (!viewCoupon) {
      setShowCoupon(false);
    }
  };
  const navigateToCoupons = () => {
    const targetDiv = document.getElementById("couponDiv");
    if (targetDiv) {
      targetDiv.scrollIntoView({
        behavior: "smooth", // Use smooth scrolling
        block: "start", // Align the top of the target element with the top of the visible area
      });
    }
  };
  useEffect(() => {
    if (!isEmpty(coupons)) {
      if (reqForGenerate) {
        setLoginScreen(false);
        navigateToCoupons();
        handleGenerateCoupon(couponData);
        setReqForGenerate(false);
      }
    }
  }, [currentUser, coupons]);
  const [activeIndex, setActiveIndex] = useState(0);
  const cardRefs = useRef([]);
  const sliderRef = useRef(null);
  useEffect(() => {
    const slider = sliderRef.current;
    const handleScroll = () => {
      const sliderWidth = slider.offsetWidth;
      const sliderLeft = slider.getBoundingClientRect().left;
      const activeSlide = Array.from(slider.children).find((slide) => {
        const slideLeft = slide.getBoundingClientRect().left;
        return slideLeft >= sliderLeft;
      });
      setActiveIndex(
        activeSlide ? Array.from(slider.children).indexOf(activeSlide) : 0
      );
    };
    slider?.addEventListener("scroll", handleScroll);
    return () => slider?.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSlideChange = (index) => {
    setActiveIndex(index);
    if (cardRefs.current[index]) {
      cardRefs.current[index].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  };

  const handleNext = () => {
    let currentIndex = activeIndex;
    let nextIndex;
    if (currentIndex + 1 == coupons?.length) {
      nextIndex = currentIndex;
    } else {
      nextIndex = currentIndex + 1;
    }
    setActiveIndex(nextIndex);
    if (cardRefs.current[nextIndex]) {
      cardRefs.current[nextIndex].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  };

  const handlePrevious = () => {
    let currentIndex = activeIndex;
    let prevIndex;
    if (currentIndex == 0) {
      prevIndex = currentIndex;
    } else {
      prevIndex = currentIndex - 1;
    }
    setActiveIndex(prevIndex);
    if (cardRefs.current[prevIndex]) {
      cardRefs.current[prevIndex].scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  };
  const dots = (couponArray) => {
    const newCouponArray = couponArray?.filter((obj) => !obj?.showPopUp);
    return newCouponArray?.map((_, index) => (
      <CarouselDot
        key={index}
        active={index === activeIndex}
        id={`dot-${index}`}
        onClick={() => handleSlideChange(index)}
      />
    ));
  };
  return (
    <>
      {showCouponCart && (
        <CouponCart
          setShowCouponCart={setShowCouponCart}
          setCoupons={setCoupons}
        />
      )}
      {!isEmpty(selectedCoupons) && (
        <CartBanner setShowCouponCart={setShowCouponCart} />
      )}
      {showCoupon && (
        <CouponDetails
          setShowPopup={setShowCoupon}
          data={couponData}
          handleSelectCoupon={handleSelectCoupon}
        />
      )}
      {loginScreen && (
        <CouponLoginScreen
          setShowPopup={setLoginScreen}
          data={couponData}
          handleLogin={handleLogin}
        />
      )}
      <div className={`${styles.couponsParent} py-[30px] bg-white`}>
        <div className="w-full max-w-[1440px] px-0  mx-auto">
          <h3 className="mb-[20px] pl-[16px]">All Coupons</h3>
          <div
            className={`flex box  gap-[16px] pr-[16px] overflow-x-auto w-full pb-[20px] pl-[16px]`}
            ref={sliderRef}
          >
            {coupons?.map((obj, index) => {
              if (!obj?.showPopUp)
                return (
                  <CouponTemplate1
                    data={obj}
                    handleShowCoupon={handleShowCoupon}
                    loading={loading}
                    handleSelectCoupon={handleSelectCoupon}
                    handleGenerateCoupon={handleGenerateCoupon}
                    sliderRef={(element) => {
                      cardRefs.current[index] = element;
                    }}
                  />
                );
            })}
          </div>
          {coupons?.length > 1 && (
            <div className="flex items-center justify-center gap-[5px] ">
              <button
                onClick={handlePrevious}
                // style={navigateButton}
                className=" top-[45%] z-10 left-[5px] cursor-pointer hidden md:flex w-[30px] h-[30px] rounded-full  items-center justify-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="7"
                  height="11"
                  viewBox="0 0 7 11"
                  fill="none"
                >
                  <path
                    d="M6.71106 0.244134C6.33051 -0.081378 5.71346 -0.081378 5.33292 0.244134L0.570187 4.32225C-0.190306 4.97336 -0.190013 6.0285 0.570773 6.67936L5.33643 10.7559C5.71697 11.0814 6.33402 11.0814 6.71457 10.7559C7.09514 10.4303 7.09514 9.90253 6.71457 9.57699L2.63572 6.08793C2.25508 5.76242 2.25508 5.2346 2.63572 4.90909L6.71106 1.42298C7.09162 1.09747 7.09162 0.56973 6.71106 0.244134Z"
                    fill={coupons?.textColor || "black"}
                  />
                </svg>
              </button>
              <div className="w-fit flex items-center justify-center gap-[6px] relative z-1 h-fit">
                {dots(coupons)}
              </div>

              <buttton
                onClick={handleNext}
                // style={navigateButton}
                className=" top-[45%] z-10 right-[5px] cursor-pointer hidden md:flex w-[30px] h-[30px] rounded-full  items-center justify-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="7"
                  height="11"
                  viewBox="0 0 7 11"
                  fill="none"
                >
                  <path
                    d="M0.288944 10.7559C0.669493 11.0814 1.28654 11.0814 1.66708 10.7559L6.42981 6.67775C7.19031 6.02664 7.19001 4.9715 6.42923 4.32064L1.66357 0.244147C1.28303 -0.0813822 0.665985 -0.0813822 0.285426 0.244147C-0.0951421 0.569684 -0.0951421 1.09747 0.285426 1.42301L4.36428 4.91207C4.74492 5.23758 4.74492 5.7654 4.36428 6.09091L0.288944 9.57702C-0.0916245 9.90253 -0.0916245 10.4303 0.288944 10.7559Z"
                    fill={coupons?.textColor || "black"}
                  />
                </svg>
              </buttton>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
